import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cn from 'classnames';

import './brLoader.scss';

export default class BrLoader extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    loadingMsg: PropTypes.string,
    withOverlay: PropTypes.bool,
  };

  static defaultProps = {
    loadingMsg: 'Loading',
    withOverlay: false,
  };

  render() {
    const { className, withOverlay } = this.props;
    const classname = cn('br-loader', withOverlay && 'with-overlay', className);
    return (
      <div className={classname} data-id="br-loader">
        <div className="loading-img" />
        <span>{this.props.loadingMsg}</span>
      </div>
    );
  }
}
